<template>
  <div class="bg-gray-900 text-white rounded-md shadow-lg m-10 p-4">
    <pre class="text-right text-cyan-300 font-bold animate-pulse -skew-x-12 opacity-40">
      ALIGND ™️
    </pre>
    <pre 
      class="overflow-x-auto text-sm leading-relaxed" 
      v-html="formattedJson"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  data: {
    type: [Object, Array, String],
    required: true
  }
});

const highlightJson = (json) => {
  if (typeof json !== "string") {
    json = JSON.stringify(json, null, 2);
  }
  return json.replace(
    /"(.*?)":\s("(.*?)"|\d+|true|false|null)/g,
    (match, key, value) => {
      return `"${key}": <span class="text-green-400">${value}</span>`;
    }
  );
};

const formattedJson = computed(() => highlightJson(props.data));
</script>

<style scoped>
/* Add any additional styles here if needed */
</style>